import React, { FC, useState } from 'react';
import { Cue } from '../../helpers/events/types';
import { trackMixpanelEvent, MPEventProperty, MPEventName } from '../../mixpanel';
import ArchiveWebEventModal from '../ArchiveWebEventModal';
import moment from 'moment';
import { theme, ThemeProvider, Tooltip } from '@resi-media/resi-ui';

interface ArchiveWebEventButtonProps {
  disableButton: boolean;
  auth: any;
  cues?: Cue[];
  webPlayer: any;
  webEventId?: string;
  webEventProfileId?: string;
  customerId?: string;
  webEventName?: string;
  startTime?: string;
}

const ArchiveWebEventButton: FC<ArchiveWebEventButtonProps> = ({
  disableButton,
  auth,
  cues,
  webPlayer,
  webEventId,
  customerId,
  webEventProfileId,
  webEventName,
  startTime,
}): JSX.Element => {
  const [isOpenArchiveWebEventModal, setIsOpenArchiveWebEventModal] = useState(false);

  const handleArchiveWebEventBtnClick = (): void => {

    const duration = webPlayer.getDuration();
    const formattedDuration = moment.utc(duration * 1000).format('HH:mm:ss');
    const formattedStartDate = moment(startTime).format('MMM D, YYYY');

    trackMixpanelEvent(
      MPEventName.LIBRARY_SAVE_INITIATED, {
        [MPEventProperty.TITLE]: webEventName,
        [MPEventProperty.START_DATE]: formattedStartDate,
        [MPEventProperty.TRANSCODED_EVENT_UUID]: webEventId,
        [MPEventProperty.DURATION]: formattedDuration,
      }
    )

    if (webPlayer) {
      webPlayer.getVideo().pause();
    }
    setIsOpenArchiveWebEventModal(true);
  };

  const tooltipMsg = (
    <h6>Unfortunately, the web event profile used for this web event<br/>is not currently compatible with the Library. <a href='https://docs.resi.io/articles/#!resi-resources-setup-actions-and-behaviors-within-control/save-to-library-compatibility'>Learn more</a></h6>
  );

  return (
    <div>
      {disableButton ?
        <ThemeProvider theme={theme}>
          <Tooltip
              innerJSX={tooltipMsg}
              position="top-center">
            <button className="btn btn-primary" onClick={(): void => handleArchiveWebEventBtnClick()} disabled={disableButton}>
              <i className="fa fa-save" aria-hidden="true" style={{ marginRight: 7 }}></i>
              Save to Library
            </button> 
          </Tooltip>
        </ThemeProvider>
      :
        <button className="btn btn-primary" onClick={(): void => handleArchiveWebEventBtnClick()}>
          <i className="fa fa-save" aria-hidden="true" style={{ marginRight: 7 }}></i>
          Save to Library
        </button> 
      }
      {isOpenArchiveWebEventModal && (
        <ArchiveWebEventModal
          auth={auth}
          cues={cues}
          handleCloseModal={(): void => setIsOpenArchiveWebEventModal(false)}
          webEventId={webEventId}
          customerId={customerId}
          webEventProfileId={webEventProfileId}
          webEventName={webEventName}
          webEventDuration={webPlayer.getDuration()}
        />
      )}
    </div>
  );
};

ArchiveWebEventButton.displayName = 'ArchiveWebEventButton';

export default ArchiveWebEventButton;
